import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { request } from "../utils/api";
import { logoutUser } from "../Auth";
import { LockIcon, ViewIcon, ViewOffIcon } from "../Icons";
import { useNavigate } from "react-router-dom";
import { FORM_FIELD } from "../ui/formTheme";
import {
  EMPLOYEE_BTN,
  EMPLOYEE_FORM,
} from "../components/Employees/employeeTheme";

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate(); // Initialize navigate

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match.");
            return;
        }

        if (newPassword.length < 6) {
            toast.error("Password must be at least 6 characters.");
            return;
        }

        setIsSubmitting(true);

        try {
            await request('/change-password', {
                method: 'POST',
                body: JSON.stringify({ newPassword })
            });

            toast.success("Password changed successfully! Logging out...");

            // Wait a moment for the toast to be visible, then logout
            setTimeout(() => {
                logoutUser();
                navigate("/login", { replace: true });
            }, 1000);

        } catch (error) {
            console.error("Change password error:", error);
            toast.error(error.message || "Failed to change password.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={`max-w-2xl mx-auto mt-10 ${EMPLOYEE_FORM.card}`}>
            <div className="flex items-center gap-3 mb-6 border-b border-indigo-100 pb-4">
                <div className="p-2 rounded-lg bg-indigo-50 text-indigo-600 border border-indigo-100">
                    <LockIcon size={24} />
                </div>
                <div>
                    <h1 className={EMPLOYEE_FORM.title}>Change Password</h1>
                    <p className="text-sm text-slate-500">Update your account security</p>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                    <label className={FORM_FIELD.label}>
                        New Password
                    </label>
                    <div className="relative">
                        <input
                            type={showNewPassword ? "text" : "password"}
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className={`${FORM_FIELD.control} ${FORM_FIELD.enabled} pr-12`}
                            required
                        />
                        <button
                            type="button"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-indigo-600 transition-colors p-1"
                        >
                            {showNewPassword ? <ViewOffIcon size={20} /> : <ViewIcon size={20} />}
                        </button>
                    </div>
                </div>

                <div>
                    <label className={FORM_FIELD.label}>
                        Confirm New Password
                    </label>
                    <div className="relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Re-enter new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className={`${FORM_FIELD.control} ${FORM_FIELD.enabled} pr-12`}
                            required
                        />
                        <button
                            type="button"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-indigo-600 transition-colors p-1"
                        >
                            {showConfirmPassword ? <ViewOffIcon size={20} /> : <ViewIcon size={20} />}
                        </button>
                    </div>
                </div>

                <div className="pt-2">
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full ${EMPLOYEE_BTN.primary}`}
                    >
                        {isSubmitting ? (
                            <>
                                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <span>Updating Password...</span>
                            </>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                                <span>Change Password</span>
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ChangePassword;
